import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/terms")({
  component: TermsOfService,
});

function TermsOfService() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
      <p className="text-sm text-muted-foreground mb-8">
        Last updated: April 27, 2026
      </p>

      <div className="space-y-8 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold mb-2">Agreement</h2>
          <p>
            By creating an account or using Lifter, you agree to these terms.
            Lifter is operated by Matt McFadyen, a sole proprietor based in
            Canada. These terms are governed by the laws of Canada.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Subscription</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              Lifter offers a <strong>30-day free trial</strong> followed by an
              auto-renewing monthly subscription at <strong>$7 CAD/month</strong>
            </li>
            <li>
              Your subscription automatically renews each month unless cancelled
              at least 24 hours before the end of the current period
            </li>
            <li>
              Payment is charged to your Apple ID account at confirmation of
              purchase
            </li>
            <li>
              You can manage or cancel your subscription at any time in iOS
              Settings → Apple ID → Subscriptions
            </li>
            <li>
              Cancellation takes effect at the end of the current billing period
              — you retain access until then
            </li>
            <li>
              Price is in Canadian dollars. Apple may convert to your local
              currency.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Refunds</h2>
          <p>
            Refund requests for the current billing period are handled through
            Apple. We approve first-time refund requests for users who contact
            support within 7 days of a charge. Contact{" "}
            <a
              href="mailto:support@getlifter.app"
              className="text-primary underline"
            >
              support@getlifter.app
            </a>{" "}
            or request a refund directly via Apple.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Abuse or attempt to circumvent AI usage limits</li>
            <li>Use the service for any unlawful purpose</li>
            <li>Attempt to access other users' data</li>
            <li>Reverse engineer or attempt to extract proprietary content</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Health Disclaimer</h2>
          <p>
            Lifter provides workout tracking and AI-generated progressive
            overload suggestions. This is not medical advice. Consult a qualified
            professional before starting any exercise program, especially if you
            have injuries or health conditions.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">
            Limitation of Liability
          </h2>
          <p>
            Lifter is provided "as is" without warranty of any kind. To the
            maximum extent permitted by law, Matt McFadyen is not liable for any
            indirect, incidental, or consequential damages arising from your use
            of the service.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Termination</h2>
          <p>
            We may suspend or terminate accounts that violate these terms. You
            may delete your account at any time from the Account screen in the
            app.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Changes to Terms</h2>
          <p>
            We may update these terms. Continued use of the service after changes
            constitutes acceptance. Material changes will be communicated via
            email or in-app notice.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Contact</h2>
          <p>
            Questions about these terms:{" "}
            <a
              href="mailto:support@getlifter.app"
              className="text-primary underline"
            >
              support@getlifter.app
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
